export const pageOverviewBannerQuery = () => {
  return `
    ... on PageOverviewBanner {
      title
      titleMobile
      subTitle
      subText
      subTextMobile
      buttons: buttonsCollection(limit: 3) {
        items {
          sys {
            id
          }
          primaryButtonText
          secondaryButtonText
          function
          color
          buttonLink
          appStoreUrl
          googlePlayUrl
          email
          openInNewTab
          hideOnLoggedIn
        }
      }
      theme
      image {
        contentType
        url
        description
      }
      imageMobile {
        contentType
        url
        description
      }
      heroAsset {
        contentType
        url
        description
      }
      loginTitle
      loginMobileTitle
      loginSubtext
      widget
    }
  `;
};

export const seoSectionQuery = () => `
  ... on SeoSection {
    title
    seoList
    width
    longForm {
      json
    }
    backgroundColor
  }
`;
